<template>
  <!-- ホルター解析依頼詳細 -->
  <div id="HolterAnalysisOrderDetail">
    <div id="container">
      <div class="labelTitle lable">ホルター心電解析依頼</div>
      <div class="button-area">
        <b-button class="backButton is-primary" v-on:click="back" :disabled="isEditable">戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr>
              <th>受付番号</th>
              <td>
                <span style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{targetNumber}}</span>
                <!-- 依頼済みでない場合 -->
                <b-button v-if="(data.editFlag || data.reExaminationFlag) && !isEditable" class="editButton is-primary" icon-left="comment-edit-outline" @click="doEdit">編集</b-button>
                <b-button v-if="(data.editFlag || data.reExaminationFlag) && isEditable" class="editButton is-primary" icon-left="content-save-outline " @click="doSave">保存</b-button>
              </td>
            </tr>
            <tr>
              <th>組織ID</th>
              <td>{{data.belongsId}}</td>
            </tr>
            <tr>
              <th>医療機関名</th>
              <td><span style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.hospital}}</span></td>
            </tr>
            <tr>
              <th>医師名</th>
              <td>{{data.docterName}}</td>
            </tr>
            <tr>
              <th>機種</th>
              <td>{{data.instrumentKind}}<span v-if="data.depositMachineFlag" class="depo"/></td>
            </tr>
            <tr v-if="data.analysisOption !== '1'"> <!-- オプションなしの場合、表示しない -->
              <th>レポート形式</th>
              <td>ホルター心電解析専用レポート</td>
            </tr>
            <tr>
              <th>機器シリアル</th>
              <td>{{data.serial}}</td>
            </tr>
            <tr>
              <th>検査期間</th>
              <td>{{data.inspectionPeriod | getNameFilter(inspectionPeriodList)}}</td>
            </tr>
            <tr>
              <th>解析オプション</th>
              <td>{{data.analysisOption | getNameFilter(analysisOptionList)}}</td>
            </tr>
            <tr>
              <th>返却希望日</th>
              <td>{{data.returnDate}}</td>
            </tr>
            <tr>
              <th>診察券ID（患者ID）<span class="require" /></th>
              <td v-if="!isEditable">{{data.patientId}}</td>
              <td v-if="isEditable"><input type="text" v-model="data.patientId" @input="data.patientId = $event.target.value.replace(/^\s+/, '')" class="edit" name="診察券ID（患者ID）" validate="required" maxlength="50"/></td>
            </tr>
            <tr>
              <th>患者名<span class="require" /></th>
              <td v-if="!isEditable">{{data.patientFamilyName}} {{data.patientFirstName}}</td>
              <td v-if="isEditable">
                <input type="text" style="margin-right: 5px; width: 460px !important;" placeholder="姓" v-model="data.patientFamilyName" class="edit" :name="'患者名(姓)'" validate="required|patientName" maxlength="49"/>
                <input type="text" style="width: 460px !important;" placeholder="名" v-model="data.patientFirstName" class="edit" :name="'患者名(名)'" validate="required|patientName" maxlength="49"/>
              </td>
            </tr>
            <tr>
              <th>患者名（カナ）</th>
              <td v-if="!isEditable">{{data.patientFamilyNameKana}} {{data.patientFirstNameKana}}</td>
              <td v-if="isEditable" style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">
                <input type="text" style="margin-right: 5px; width: 460px !important;" placeholder="セイ" v-model="data.patientFamilyNameKana" class="edit" :name="'患者名カナ(セイ)'" validate="required|patientNameKana" maxlength="49"/>
                <input type="text" style="width: 460px !important;" placeholder="メイ" v-model="data.patientFirstNameKana" class="edit" :name="'患者名カナ(メイ)'" validate="required|patientNameKana" maxlength="49"/>
              </td>
            </tr>
            <tr>
              <th>性別<span class="require" /></th>
              <td v-if="!isEditable">{{data.gender}}</td>
              <td v-if="isEditable">
                <div class="block">
                  <b-radio class="td_radio" v-model="data.gender" native-value="-">-</b-radio>
                  <b-radio class="td_radio" v-model="data.gender" native-value="男">男</b-radio>
                  <b-radio class="td_radio" v-model="data.gender" native-value="女">女</b-radio>
                </div>
              </td>
            </tr>
            <tr>
              <th>生年月日<span class="require" /></th>
              <td v-if="!isEditable">{{data.birthday}}</td>
              <td v-if="isEditable"><input type="date" v-model="data.birthday" :input="inputBirthday()" class="edit" name="生年月日" validate="date|birthDay|required" :max="yyyy_hyp_MM_hyp_dd(new Date())"/></td>
            </tr>
            <tr>
              <th>年齢</th>
              <td >{{data.age}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">患者備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">配送備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryInformationNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receptionNote}}</td>
            </tr>
            <tr><th>デモ</th><td><b-checkbox style="width: 26px" v-model="data.demo" disabled />デモ(トライアル)</td></tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.belongsNote}}</td>
            </tr>
            <tr v-if="data.editFlag && !isEditable"><th>症状記録シートの有無<span class="require" /></th>
              <td>
                <div class="edit" validate="radioRequire" name='症状記録シートの有無'>
                  <b-radio class="td_radio" name="recordingSheet" v-model="recordingSheet" native-value="">有</b-radio>
                  <b-radio class="td_radio" name="recordingSheet" v-model="recordingSheet" native-value="【記録シート：無】">無</b-radio>
                </div>
              </td>
            </tr>
            <tr>
              <th>申送り事項</th>
              <td v-if="data.editFlag"><textarea class="memo" maxlength="256" v-model="data.memo" style="resize:vertical;max-width:100%;" :disabled="isEditable"/></td>
              <td v-else><span style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.memo}}</span></td>
            </tr>
            <tr v-if="data.editFlag && !isEditable">
              <th style="vertical-align:top;">アップロードファイル名</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;"><span>{{uploadFileName}}<b-button class="clipbordcopy is-primary" @click="clipboardCopy()">コピーする</b-button></span></td>
            </tr>
            <tr v-if="!isEditable">
              <th>添付データアップロード<span class="require" /></th>
              <td>
                <template v-if="data.editFlag && !isEditable">
                  <div class="upload_area uploadArea" @dragenter="dragEnter">
                    ここに添付する解析データをドラッグアンドドロップするか、「ファイルを追加」を押します。
                  </div>
                  <b-modal :active.sync="isUpdateModal" has-modal-card>
                    <div class="modal-card uploadModal" 
                     @dragleave="dragLeave"
                     @drop.prevent="fileDorop"
                    >ここに解析データファイルをドロップします。</div>
                  </b-modal>
                  <b-upload v-model="upButtonFile"  class="file-label" v-on:input="addUploadfile" multiple>
                    <span class="file-cta">
                      <span class="file-label">ファイルを追加</span>
                    </span>
                  </b-upload>
                  <ul class="upfileList">
                    <li v-for="(file,index) of data.attachedDataFileList" :key="index">
                      <div v-if="file.ctrl" class="fileNameArea line-through"><b-icon icon="paperclip" />{{file.name}}</div>
                      <div v-else class="fileNameArea"><b-icon icon="paperclip" />{{file.name}}<a @click="deleteUpfile(index)"><b-icon icon="delete-forever-outline" /></a></div>

                    </li>
                  </ul>
                </template>
                <template v-else>
                  <ul>
                    <li v-for="(file,index) of data.attachedDataFileList" :key="index">
                      <template v-if="file.fileAddress"><a @click="downloadFile(file.fileAddress, file.fileId)"><b-icon icon="paperclip" />{{file.name}}</a></template>
                      <template v-else><b-icon icon="paperclip" />{{file.name}}</template>
                    </li>
                  </ul>
                </template>
              </td>
            </tr>
          </table>
        </div>
        <div class="button-area">
          <!-- 未依頼 -->
          <span v-if="data.editFlag">
            <b-button class="opButton is-primary" icon-left="offer" :disabled="isEditable" v-on:click="analysisRequest">解析依頼</b-button>
          </span>
          <b-button v-if="data.editFlag" class="opButton reInspectionButton is-primary" :disabled="isEditable" icon-left="file-question-outline" @click="reasonInputModalActive=true">再検査調整</b-button>
          <!-- 再検査調整中 -->
          <b-button v-if="!data.editFlag && data.reExaminationFlag && !data.depo" class="opButton is-primary" :disabled="isEditable" v-on:click="confirmReExamination">再検査を実施する</b-button>
          <b-button v-if="!data.editFlag && data.reExaminationFlag" class="opButton reInspectionButton is-primary" :disabled="isEditable" @click="cancelReasonInputModalActive=true">検査をキャンセル</b-button>
        </div>
        <b-modal :active.sync="reasonInputModalActive" has-modal-card>
          <reInspectModal  v-on:setReason="reExaminationAdjustment" v-bind:title="'再検査調整(再検査理由入力)'" :targetChoiceValue="data.instrumentKindValue" :targetScreenName="'holterAnalysisOrderDetail'" :targetChoiceType="choicesType.holterKind"></reInspectModal>
        </b-modal>
        <b-modal :active.sync="cancelReasonInputModalActive" has-modal-card>
          <reasonInputModal  v-on:setReason="cancel" v-bind:title="'検査キャンセル(キャンセル理由入力)'"></reasonInputModal>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import { choicesType, reExaminationConfirmTemplate } from "@/components/mock/base/const.js";
import {UploadType} from "@/components/mock/base/const.js";
import {reportFormat} from "@/components/mock/base/const.js";
import reasonInputModal from "@/components/mock/philips/common/reasonInputModal";
import reInspectModal from "@/components/mock/philips/common/reInspectModal";

const CLOSING_TIME = 17;
const HOLIDAY_JP = require("@holiday-jp/holiday_jp");
const PH_HOLIDAYS = require('@/components/mock/base/philipsHollday.json');

export default {
  name: "HolterAnalysisOrderDetail",
  methods: {
    back: function() {
      this.$router.push({
        name: "HolterAnalysisOrder",
        params: { searchConditions: this.searchParams },
      });
    },
    test: function(){
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if (this.data.attachedDataFileList.length==0){
        errMsg = errMsg + "添付データが選択されていません。\n"
      }else{
        let nameList = this.data.attachedDataFileList.map(item => this.getUploadFileName(item));
        for(let i =0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            //フォルダの場合はzip名にしてチェック
            nameList[i] = nameList[i].replace("/", "") + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
        }
      }
      let targetFile = this.data.attachedDataFileList.filter(item => item.file);
      let okSize = this.checkUploadFileSize(targetFile);
      if(!okSize){
        errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
      }
      if (errMsg != ""){
        this.showErrorMessage(errMsg)
        return
      }

      if(!this.checkUploadFileName(this.data.attachedDataFileList)){
        return
      }
    },
    dragEnter: function() {
      this.isUpdateModal = true;
    },
    dragLeave: function() {
      this.isUpdateModal = false;
    },
    fileDorop: async function(event) {
      for(let i =0 ; i < event.dataTransfer.items.length; i++){
        const item = event.dataTransfer.items[i];
        const entry = item.webkitGetAsEntry();
        let path = entry.name;
        if(entry.isDirectory){
          path = entry.fullPath;
        }
        this.data.attachedDataFileList.push({ file: entry, path: path , name:entry.name});
      }
      this.isUpdateModal = false;
    },
    addUploadfile: function(){
      for(let upFile of this.upButtonFile){
        this.data.attachedDataFileList.push({ file: upFile, path: upFile.name,name:upFile.name })
      }
      this.upButtonFile = [];
    },
    deleteUpfile: function(index) {
      this.data.attachedDataFileList.splice(index, 1);
    },
    downloadFile: function(fileAddress, fileId){
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.apiCommon.getDownloadFilePOST({
            body:{
              fileId:fileId,
              fileName:fileAddress,
              updFileInfoFlg:false
            }
          });
        },
        function(result){
          if(result != null && result.status == 200){
            var downloadUrl = result.obj.downloadUrl;
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.href = downloadUrl;
            let targetFile = fileAddress.toLowerCase();
            if(targetFile.endsWith(".pdf")){
                a.target="_blank"
            }
            a.click();
            a.remove();
          } else if(result != null){
            _this.showErrorMessage(result.message);
          } else {
            _this.showErrorMessage("予期しないエラーが発生しました。");
          }
        },
        function(error){
          // エラーメッセージ表示
          _this.showErrorMessage(error);
        }
      );

    },
    doSearch: function() {
      var excuteApi = this.getHolterAnalysisRequestDetailPOST;
      var successCallBack = this.getHolterAnalysisRequestDetailPOSTSuccess;
      var errorCallBack = this.getHolterAnalysisRequestDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterAnalysisRequestDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterAnalysisRequestDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHolterAnalysisRequestDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
      this.uploadFileName = this.data.patientId + "_" + this.data.requestDate + "_" + this.data.hospitalName + "_" + this.data.patientFamilyName + " " + this.data.patientFirstName + "様"
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g,'_')

      // 申込み日が土日祝、年末年始、PHILIPS特別休日の場合及び申込み日時が17時以降の場合を考慮する
      let holiday = false;
      let baseDay = new Date();
      let comparedDateHour = new Date().getHours();

      if(baseDay.getDay() == 0 || baseDay.getDay() == 6 || HOLIDAY_JP.between(baseDay, baseDay).length != 0){ // 土日または祝日の場合
        holiday = true;
      }else{
        let formatedDay = this.MM_hyp_dd(baseDay);
        if(PH_HOLIDAYS.everyyear.includes(formatedDay)){ // 年末年始の場合
          holiday = true
        }else{
          formatedDay = this.yyyy_hyp_MM_hyp_dd(baseDay);
          if(PH_HOLIDAYS.irregular.includes(formatedDay)){ // PHILIPS特別休日の場合
            holiday = true
          }
        }
      }

      if(this.data.instrumentKind.indexOf("ePatch") > -1){
        let reportFormat = '';
        let returnDate = '';
        if(this.data.analysisOption == "1"){  // オプションなしの場合(2営業日後)
          reportFormat = this.reportFormat.holterAnalysisReport;
          // 申込み日が休日又は申込み日時が17時以降の場合は1日追加
          if (holiday || (comparedDateHour >= CLOSING_TIME)) {
            returnDate = this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 3))
          } else {
            returnDate = this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 2))
          }
        } else if(this.data.analysisOption == "2"){ // 専門医の判定付の場合(4営業日後)
          reportFormat = this.reportFormat.holterAnalysisReport;
          // 申込み日が休日又は申込み日時が17時以降の場合は1日追加
          if (holiday || (comparedDateHour >= CLOSING_TIME)) {
            returnDate = this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 5))
          } else {
            returnDate = this.yyyy_sla_MM_sla_dd(this.getBusinessDay(new Date(), 4))
          }
        }
        this.data.reportFormat = reportFormat;

        let displayReturnDate = returnDate;
        if (this.data.judgmentDoctorFlag) {
          displayReturnDate = this.yyyy_sla_MM_sla_dd(
            this.getBusinessDay(new Date(returnDate), 2)
          );
        }
        this.data.returnDate = displayReturnDate;
      }
    },
    getHolterAnalysisRequestDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result.message,this.back());
    },
    doEdit: function() {
      this.data.birthday = this.data.birthday ? this.data.birthday.replaceAll("/","-") : this.data.birthday
      this.isEditable = true;
    },
    doSave: function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else{
        this.data.birthday = this.data.birthday ? this.data.birthday.replaceAll("-","/") : this.data.birthday
        this.isEditable = false;
      }
      this.uploadFileName = this.data.patientId + "_" + this.data.requestDate + "_" + this.data.hospitalName + "_" + this.data.patientFamilyName + " " + this.data.patientFirstName + "様"
      this.uploadFileName = this.uploadFileName.replace(/[\\/:*?"<>|]/g,'_')
    },
    inputBirthday: function() {
      var age = this.getAge(this.data.birthday)
      if(!isNaN(Number(age))){
        this.data.age = age < 0 ? 0 : age
      }else{
        this.data.age = ""
      }
    },
    analysisRequest: async function() {
      // バリデーションチェック
      var elements = document.getElementsByClassName("edit")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if (this.data.attachedDataFileList.length==0){
        errMsg = errMsg + "添付データが選択されていません。\n"
      }else{
        let nameList = this.data.attachedDataFileList.map(item => this.getUploadFileName(item));
        for(let i =0; i < nameList.length; i++){
          if(nameList[i].startsWith("/")){
            //フォルダの場合はzip名にしてチェック
            nameList[i] = nameList[i].replace("/", "") + ".zip"
          }
        }
        const setElements = new Set(nameList);
        if (setElements.size !== nameList.length) {
          errMsg = errMsg + "添付データの重複しているファイルが存在します。\n"
        }
      }
      let targetFile = this.data.attachedDataFileList.filter(item => item.file);
      let okSize = await this.checkUploadFileSize(targetFile);
      if(!okSize){
        errMsg = errMsg + "2GBを超えるファイルはアップロードできません。\n"
      }
      if (errMsg != ""){
        this.showErrorMessage(errMsg)
        return
      }

      if(!this.checkUploadFileName(this.data.attachedDataFileList)){
        return
      }

      //まずはファイルのアップロード
      this.multipleUpload(targetFile ,this.targetNumber, this.UploadType.holter_data, "ホルター解析依頼データ")
      .then(result =>{
        // 解析依頼
        var excuteApi = this.setHolterAnalysisRequestPOST;
        var successCallBack = this.setHolterAnalysisRequestPOSTSuccess;
        var errorCallBack = this.setHolterAnalysisRequestPOSTError;
        // Web Api Call
        this.apiCall(excuteApi, successCallBack, errorCallBack);
      })
      .catch(error =>{
        this.showErrorMessage("ファイルアップロードに失敗した為、申込みをキャンセルしました。<br>再度実行してください。");
        return
      });
    },
    getUploadFileName: function(uploadItemIfno) {
      if(!uploadItemIfno){
        return ""
      }
      return uploadItemIfno.path || uploadItemIfno.name || (uploadItemIfno.file ? uploadItemIfno.file.name : "")
    },
    checkUploadFileName: function(files) {
      for(let uploadItemIfno of files){
        var name = this.getUploadFileName(uploadItemIfno)
        if(name.indexOf(".") != -1 && name.indexOf(this.uploadFileName) == -1){
          this.showErrorMessage("添付したファイルの診察券ID、申込日、医療機関名、患者名が正しくない可能性があります。")
          return false
        }
      }
      return true
    },
    setHolterAnalysisRequestPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.patientId = obj.patientId ? obj.patientId.replace(/^\s+/, "") : obj.patientId
      obj.belongsId = this.belongsId
      obj.receiptNumber = this.targetNumber

      // 申込み日が土日祝、年末年始、PHILIPS特別休日の場合及び申込み日時が17時以降の場合を考慮する
      // 画面表示時と解析依頼ボタン押下までにタイムラグがあるため、同じ処理をもう一度行う
      let holiday = false;
      let baseDay = new Date();
      let comparedDateHour = new Date().getHours();

      if(baseDay.getDay() == 0 || baseDay.getDay() == 6 || HOLIDAY_JP.between(baseDay, baseDay).length != 0){ // 土日または祝日の場合
        holiday = true;
      }else{
        let formatedDay = this.MM_hyp_dd(baseDay);
        if(PH_HOLIDAYS.everyyear.includes(formatedDay)){ // 年末年始の場合
          holiday = true
        }else{
          formatedDay = this.yyyy_hyp_MM_hyp_dd(baseDay);
          if(PH_HOLIDAYS.irregular.includes(formatedDay)){ // PHILIPS特別休日の場合
            holiday = true
          }
        }
      }

      if(this.data.instrumentKind.indexOf("ePatch") > -1){
        let analysisDeadline; // 解析期限
        if(this.data.analysisOption == "1"){  // オプションなしの場合(2営業日後)
          // 申込み日が休日又は申込み日時が17時以降の場合は1日追加
          if (holiday || (comparedDateHour >= CLOSING_TIME)) {
            analysisDeadline = this.getBusinessDay(new Date(), 3)
          } else {
            analysisDeadline = this.getBusinessDay(new Date(), 2)
          }
        } else if(this.data.analysisOption == "2"){ // 専門医の判定付の場合(4営業日後)
          // 申込み日が休日又は申込み日時が17時以降の場合は1日追加
          if (holiday || (comparedDateHour >= CLOSING_TIME)) {
            analysisDeadline = this.getBusinessDay(new Date(), 5)
          } else {
            analysisDeadline = this.getBusinessDay(new Date(), 4)
          }
        }

        obj.returnDate = this.yyyy_sla_MM_sla_dd(analysisDeadline)
        
        // 返却希望日・判定期限は解析期限＋2営業日
        obj.returnDateForHolterJudgment = this.yyyy_sla_MM_sla_dd(
          this.getBusinessDay(analysisDeadline, 2)
        )
      }
      delete obj.attachedDataFileList
      //症状記録シートの有無⇒無の場合、「【記録シート：無】」を項目「申し送り事項」の入力値と文字列結合する。
      if(this.recordingSheet){
        obj.memo = this.recordingSheet + '\n' + obj.memo;
      }
      return client.apis.internalHolter.setHolterAnalysisRequestPOST({
        body:obj
      });
    },
    setHolterAnalysisRequestPOSTSuccess: function(result) {
      this.showMessage("登録が完了しました。",this.back());
    },
    setHolterAnalysisRequestPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    reExaminationAdjustment: function(reason) {
      // データなし(再検査調整)
      this.reason = reason
      var excuteApi = this.setHolterAnalysisInspectionAdjustmentPOST;
      var successCallBack = this.setHolterAnalysisInspectionAdjustmentPOSTSuccess;
      var errorCallBack = this.setHolterAnalysisInspectionAdjustmentPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterAnalysisInspectionAdjustmentPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.patientId = obj.patientId ? obj.patientId.replace(/^\s+/, "") : obj.patientId
      obj.belongsId = this.belongsId
      obj.receiptNumber = this.targetNumber
      obj.reason = this.reason
      delete obj.attachedDataFileList
      return client.apis.internalHolter.setHolterAnalysisInspectionAdjustmentPOST({
        body:obj
      });
    },
    setHolterAnalysisInspectionAdjustmentPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setHolterAnalysisInspectionAdjustmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    // 再検査実施前の確認ダイアログ表示
    confirmReExamination() {
      this.$dialog.confirm({
        title: "　",
        message: reExaminationConfirmTemplate.message,
        cancelText: reExaminationConfirmTemplate.cancelText,
        confirmText: reExaminationConfirmTemplate.confirmText,
        onConfirm: () => {
          this.reExamination();
        },
      });
    },
    reExamination: function() {
      // 再検査を実施する
      var excuteApi = this.setHolterAnalysisInspectionAgainPOST;
      var successCallBack = this.setHolterAnalysisInspectionAgainPOSTSuccess;
      var errorCallBack = this.setHolterAnalysisInspectionAgainPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterAnalysisInspectionAgainPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.patientId = obj.patientId ? obj.patientId.replace(/^\s+/, "") : obj.patientId
      obj.belongsId = this.belongsId
      obj.receiptNumber = this.targetNumber
      delete obj.attachedDataFileList
      var shortestShippingDateList = this.getShortestShippingDate()
      obj.shortestShippingDateList = shortestShippingDateList
      return client.apis.internalHolter.setHolterAnalysisInspectionAgainPOST({
        body:obj
      });
    },
    setHolterAnalysisInspectionAgainPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setHolterAnalysisInspectionAgainPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    cancel: function(cancelReason) {
      // 検査をキャンセル
      this.reason = cancelReason
      var excuteApi = this.setHolterAnalysisInspectionCancelPOST;
      var successCallBack = this.setHolterAnalysisInspectionCancelPOSTSuccess;
      var errorCallBack = this.setHolterAnalysisInspectionCancelPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterAnalysisInspectionCancelPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.data));
      obj.patientId = obj.patientId ? obj.patientId.replace(/^\s+/, "") : obj.patientId
      obj.belongsId = this.belongsId
      obj.receiptNumber = this.targetNumber
      obj.reason = this.reason
      delete obj.attachedDataFileList
      return client.apis.internalHolter.setHolterAnalysisInspectionCancelPOST({
        body:obj
      });
    },
    setHolterAnalysisInspectionCancelPOSTSuccess: function(result) {
      this.showSuccess(result,this.back());
    },
    setHolterAnalysisInspectionCancelPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    clipboardCopy: function(){
      navigator.clipboard.writeText(this.uploadFileName).then(() => {
        this.showMessage('クリップボードにコピーしました。');
      }).catch(err => {
        this.showMessage('コピーに失敗しました');
      });
    },
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var reportFormatList = this.getChoiceList(choicesType.psgReportFormat, false);
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let analysisOptionList = this.getChoiceList(choicesType.holterAnalysisOp, true);
    let inspectionPeriodList = [];
    if(this.$route.params["holterJudgmentFlg"]) {
      inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriodJudgment, true);
    }else{
      inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, true);
    }
    return {
      data: {},
      targetNumber,
      searchParams,
      reportFormatList,
      isEditable: false,
      upButtonFile:null,
      isUpdateModal: false,
      belongsId:userInfo.belongsId,
      UploadType:UploadType,
      reportFormat:reportFormat,
      reasonInputModalActive:false,
      cancelReasonInputModalActive:false,
      reason:"",
      analysisOptionList: analysisOptionList,
      inspectionPeriodList: inspectionPeriodList,
      uploadFileName:"",
      recordingSheet:null,
      choicesType
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {
    reasonInputModal:reasonInputModal,
    reInspectModal:reInspectModal
  }
};
</script>
<style lang="scss" scoped>
.editButton {
  width:150px !important;
  height:100% !important;
  float: right;
}
.memo {
  width: 100%;
}
.opButton {
  width: 220px;
}
.reInspectionButton {
  padding-left:20px;
}
.uploadModal {
  width: 900px !important;
  height:500px !important;
  display: grid !important;
  place-items: center !important;
}
.clipbordcopy {
  margin-left:3%;
  right: 10px;
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterAnalysisOrderDetail.vue